import { Progress, ProgressProps } from "@chakra-ui/react";
import React from "react";

export default function APProgressBar(props: ProgressProps) {
  return (
    <Progress
      {...props}
      value={props.value}
      borderRadius={4}
      sx={{
        background: "#f2f2f2",
        "& [role=progressbar]": { background: "primary" },

      }}
      colorScheme="green"
    />
  );
}
